import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { useRealTimeUpdates } from './hooks/useRealTimeUpdates'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Conversations from './pages/Conversations'
import ConversationDetails from './pages/ConversationDetails'
import Knowledge from './pages/Knowledge'
import KnowledgeDetails from './pages/KnowledgeDetails'
import Inquiries from './pages/Inquiries'
import InquiryDetails from './pages/InquiryDetails'
import Analytics from './pages/Analytics'
import Branding from './pages/Branding'
import Settings from './pages/Settings'
import LoadingSpinner from './components/LoadingSpinner'

// Authenticated app component with real-time updates
const AuthenticatedApp: React.FC = () => {
  const { isConnected } = useRealTimeUpdates()

  return (
    <Layout isConnected={isConnected}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/conversations/:id" element={<ConversationDetails />} />
        <Route path="/inquiries" element={<Inquiries />} />
        <Route path="/inquiries/:id" element={<InquiryDetails />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/knowledge/:id" element={<KnowledgeDetails />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <NotificationProvider>
      <AuthenticatedApp />
    </NotificationProvider>
  )
}

export default App